import React from 'react';
import { StyledCardCarousel } from './StyledCardCarousel';

const CardCarousel = ({ image, title, text }) => {

  return (
    <React.Fragment>
      {
        <StyledCardCarousel>
          <img src={image} />
          <div className="card--text-wrap">
            <h6 className="big--title">{title}</h6>
            <p className="preset-11">{text}</p>
          </div>
        </StyledCardCarousel>
          
      }
    </React.Fragment>
  );
};


export default CardCarousel;
